import { render, staticRenderFns } from "./SettingTemplateList.vue?vue&type=template&id=07ffba4a&"
import script from "./SettingTemplateList.vue?vue&type=script&lang=ts&"
export * from "./SettingTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports